var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.0701 39.2511V11.8757H32.6836C32.4425 11.3001 32.1467 10.7784 31.8538 10.3036L31.1644 9.18645L29.9785 9.75003C29.7505 9.85823 29.5016 9.90335 29.2435 9.88353C28.5398 9.82855 27.9734 9.2554 27.9259 8.55061C27.9196 8.45774 27.9219 8.36487 27.9327 8.27454C28.1465 6.48801 27.5511 4.75685 26.299 3.5252C26.1126 3.3419 26.0066 3.2418 26.0066 3.2418L24.6494 1.95947L23.7268 3.58184C23.0479 4.7755 22.0416 5.688 20.9761 6.65412C19.4824 8.00852 17.8375 9.50013 17.132 11.8758H2.92989V39.2511H0V42.4856C0 45.5486 2.492 48.0406 5.555 48.0406H44.445C47.508 48.0406 50 45.5486 50 42.4856V39.2511H47.0701ZM34.8632 22.6477V27.5312H15.1368V22.6477H34.8632ZM22.9439 8.82444C23.5977 8.23167 24.3018 7.59328 24.9553 6.85197C25.0434 7.19299 25.0681 7.55647 25.0238 7.92629C24.9914 8.197 24.9844 8.47337 25.0028 8.74758C25.1474 10.8927 26.8723 12.6367 29.015 12.8042C29.306 12.827 29.5988 12.821 29.8831 12.7873C30.1708 13.3968 30.2915 13.9002 30.2915 14.4266C30.2915 17.3443 27.9178 19.718 25 19.718C22.0822 19.718 19.7085 17.3443 19.7085 14.4266C19.7085 11.7581 21.1363 10.4635 22.9439 8.82444ZM5.85959 14.8054H16.7875C16.8725 16.6714 17.5826 18.3773 18.7128 19.718H12.2071V30.4609H37.7929V19.718H31.2872C32.4174 18.3773 33.1275 16.6714 33.2125 14.8054H44.1404V39.2511H5.85959V14.8054ZM47.0703 42.4856C47.0703 43.9332 45.8926 45.1109 44.445 45.1109H5.555C4.10744 45.1109 2.9297 43.9333 2.9297 42.4856V42.1808H47.0703V42.4856Z",
    fill: "#8956B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.207 33.3907H23.5351V36.3204H12.207V33.3907Z",
    fill: "#8956B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4648 33.3907H37.7929V36.3204H26.4648V33.3907Z",
    fill: "#8956B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.58d809d3cca7ebaf6575cee0a403caa9.svg";
export { ForwardRef as ReactComponent };